import { render } from "./NcrmPrivacyEvidenceDetailDrawer.vue?vue&type=template&id=8cdfb668&scoped=true"
import script from "./NcrmPrivacyEvidenceDetailDrawer.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyEvidenceDetailDrawer.vue?vue&type=script&lang=js"

import "./NcrmPrivacyEvidenceDetailDrawer.vue?vue&type=style&index=0&id=8cdfb668&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cdfb668"]])

export default __exports__